export default "__VITE_ASSET__QiyUL6sm__"